// extracted by mini-css-extract-plugin
var _1 = "ActivityMessage_data__yA-xB";
var _2 = "ActivityMessage_linked__gvADr";
var _3 = "ActivityMessage_linkedDeleted__8AVp7";
export { _1 as "data", _2 as "linked", _3 as "linkedDeleted" }
